/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
};

/**
 * Export `fetchModelRangeFilters`.
 */

export async function fetchModelRangeFilters({ locale }: Query): Promise<any> {
  const endpoint = getApiEndpoint('getModelRangeFilters');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data;
  } catch (error) {
    handleRequestError(error);
  }
}
